"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clear = exports.keys = exports.remove = exports.set = exports.get = exports.check = exports.isNotEmpty = exports.isNotNull = void 0;

var isNotNull = function isNotNull(variable) {
  return typeof variable !== 'undefined' && variable !== null;
};

exports.isNotNull = isNotNull;

var isNotEmpty = function isNotEmpty(variable) {
  return typeof variable !== 'undefined' && variable;
};

exports.isNotEmpty = isNotEmpty;

var check = function check(storage) {
  if (storage in window && window[storage]) return window[storage];
  throw new Error("Your Browser doesn't support ".concat(storage));
};

exports.check = check;

var get = function get(storage, key) {
  var cache = storage.getItem(key);

  if (isNotNull(cache)) {
    var cacheParsed = JSON.parse(cache);

    if (isNotNull(cacheParsed)) {
      var timeNow = new Date().getTime();
      var dateCache = cacheParsed.created;
      var expiryInMilis = parseInt(cacheParsed.expiry, 10) * 60 * 1000;
      var expiryTime = parseInt(dateCache, 10) + expiryInMilis;

      if (isNotNull(cacheParsed.expiry)) {
        if (expiryTime > timeNow) return cacheParsed.value;else storage.removeItem(key);
      } else {
        return cacheParsed.value;
      }
    }
  }

  return null;
};

exports.get = get;

var set = function set(storage, key, value, expiryInMinutes) {
  var data = {
    created: new Date().getTime(),
    value: value,
    expiry: expiryInMinutes
  };
  storage.setItem(key, JSON.stringify(data));
  return data;
};

exports.set = set;

var remove = function remove(storage, key) {
  if (get(storage, key)) {
    storage.removeItem(key);
    return true;
  }

  return false;
};

exports.remove = remove;

var keys = function keys(storage) {
  var keys = [];

  for (var i = 0; i < storage.length; i++) {
    var key = storage.key(i);
    if (get(storage, key)) keys.push(key);
  }

  return keys;
};

exports.keys = keys;

var clear = function clear(storage) {
  return storage.clear();
};

exports.clear = clear;